import axios from 'axios'
import { flagSession, removeSession } from '@/services/checksession'

/**
 * Before any API call, retrieve the clientID from the evnironmet to set the required X-IBM-Client-Id value
 **/
async function checkCredential(config) {
  if (!config.url.includes('apimanagerconsumercredentials')) {
    if (!window.api_credentials && !window.api_credentials_request) {
      window.api_credentials_request = axios
        .get('/portal/config/apimanagerconsumercredentials.json')
        .then(resp => (window.api_credentials = resp.data))
        .catch(err => console.log('Error fetching credentials ' + err))
    }
    await window.api_credentials_request
    config.headers.common['X-IBM-Client-Id'] = window.api_credentials?.clientId
  }

  return config
}

axios.interceptors.request.use(checkCredential)

export function registerUser(
  name,
  surname,
  email,
  password,
  language,
  gender,
  acceptPolicy
  //acceptTerms
) {
  return axios
    .post(process.env.VUE_APP_API_URL + 'user/create', {
      name: name,
      surname: surname,
      email: email,
      password: password,
      language: language,
      gender: gender,
      acceptTerms: true,
      acceptPolicy: acceptPolicy,
    })
    .then(resp => {
      return resp.data
    })
}

export function verificateEmail(token, email) {
  const params = new URLSearchParams()
  params.append('email', email)
  params.append('token', token)
  return axios.post(process.env.VUE_APP_API_URL + 'user/token', params).then(resp => {
    return resp.data
  })
}

export function loginUser(email, password, session) {
  const params = new URLSearchParams()
  params.append('email', email)
  params.append('password', password)
  if (session !== '') {
		params.append('session', session)
		flagSession()
	}
  return axios.post(process.env.VUE_APP_API_URL + 'user/login', params).then(resp => {
    return resp.data
  })
}

export function logoutUser() {
	removeSession()
  return axios.post(process.env.VUE_APP_API_URL + 'user/logout').then(resp => {
    return resp.data
  })
}

export function recoverUser(email) {
  const params = new URLSearchParams()
  params.append('email', email)
  return axios.post(process.env.VUE_APP_API_URL + 'user/recover', params).then(resp => {
    return resp.data
  })
}

export function changePassword(token, email, password) {
  const params = new URLSearchParams()
  params.append('token', token)
  params.append('email', email)
  params.append('password', password)
  return axios.post(process.env.VUE_APP_API_URL + 'user/token', params).then(resp => {
    return resp.data
  })
}

export async function getUserData() {
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'user/data')
    .then(resp => {
      return resp.data
    })
    .catch(function (err) {
      if (err.response.status === 429 || err.response.httpCode === '429') {
        let currentLanguage = window.location.pathname
          .split('/')
          .find(el => el === 'ca' || el === 'es' || el === 'en')
        window.location.assign('/' + currentLanguage + '/page-429')
      } else {
        return {
          code: 500,
        }
      }
    })
  return response
}

export function setUserData(name, surname, language, gender, email, password) {
  const params = new URLSearchParams()
  params.append('name', name)
  params.append('surname', surname)
  params.append('language', language)
  params.append('gender', gender)
  params.append('email', email)
  if (password !== '') params.append('password', password)
  return axios.post(process.env.VUE_APP_API_URL + 'user/data', params).then(resp => {
    return resp.data
  })
}

export function deleteUser(email) {
  const params = new URLSearchParams()
  params.append('email', email)

  return axios
    .delete(process.env.VUE_APP_API_URL + 'user/data', {
      data: params.toString(),
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    })
    .then(resp => {
      return resp.data
    })
}

export async function getUserNotif(lang) {
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'user/notifications', {
      params: { lang: lang },
    })
    .then(resp => {
      return resp.data
    })
    .catch(function (err) {
      if (err.response.status === 429 || err.response.httpCode === '429') {
        let currentLanguage = window.location.pathname
          .split('/')
          .find(el => el === 'ca' || el === 'es' || el === 'en')
        window.location.assign('/' + currentLanguage + '/page-429')
      } else {
        return {
          code: 500,
        }
      }
    })
  return response
}

export function setUserNotif(enabled, frequency, themes, defaultFav) {
  // themes: ['Poblacio', 'Poblacio, Projeccions, Poblacio']
  return axios
    .post(process.env.VUE_APP_API_URL + 'user/notifications', {
      enabled: enabled,
      frequency: frequency,
      themes: themes,
      defaultNotificationsFavourite: defaultFav,
    })
    .then(resp => {
      return resp.data
    })
}

export async function getUserFavs(
  lang,
  type,
  sortByFilter,
  start,
  rows,
  thesaurus,
  query,
  source,
  territory,
  publishDateRange
) {
  let objAxios = {
    params: { language: lang, favouriteType: type },
  }
  if (type === 'LIST') {
    objAxios.params.start = start
    objAxios.params.rows = rows
    if (query !== '') {
      objAxios.params.query = query
    }
    if (sortByFilter) {
      objAxios.params.sortByFilter = sortByFilter
    }
    if (source) {
      objAxios.params.source = source
    }
    if (thesaurus) {
      objAxios.params.thesaurus = thesaurus
    }
    if (territory) {
      objAxios.params.territory = territory
    }
    if (publishDateRange) {
      objAxios.params.publishDateRange = publishDateRange
    }
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'user/favourites', objAxios)
    .then(resp => {
      return resp.data
    })
    .catch(function (err) {
      if (err.response.status === 429 || err.response.httpCode === '429') {
        let currentLanguage = window.location.pathname
          .split('/')
          .find(el => el === 'ca' || el === 'es' || el === 'en')
        window.location.assign('/' + currentLanguage + '/page-429')
      } else {
        return {
          code: 500,
        }
      }
    })
  return response
}

export async function createUserFav(id, payload) {
  const params = new URLSearchParams()
  params.append('id', id)
  params.append('payload', payload)

  const response = await axios
    .post(process.env.VUE_APP_API_URL + 'user/favourites', params)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function editUserFav(id, payload, enabled) {
  const params = new URLSearchParams()
  params.append('payload', payload ? payload : '')
  params.append('enabled', enabled)

  const response = await axios
    .post(process.env.VUE_APP_API_URL + 'user/favourites/' + id, params)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export function deleteUserFav(id) {
  return axios.delete(process.env.VUE_APP_API_URL + 'user/favourites/' + id, {}).then(resp => {
    return resp.data
  })
}

export function requestClientID() {
  const params = new URLSearchParams()
  params.append('clientIdRequest', true)
  return axios.post(process.env.VUE_APP_API_URL + 'user/data', params).then(resp => {
    return resp.data
  })
}
